<template>
  <div class="vr-simulation">
    <div class="title-text">应用场景</div>
    <div class="yycj">
      <div v-for="(item, index) in yycjData" :key="index">
        <img :src="item.url" />
        <div class="content-title">{{ item.title }}</div>
      </div>
    </div>
    <div class="title-text">实例介绍</div>
    <div class="sljs">
      <div v-for="(item, index) in exampleDatas.xnbwg.example" :key="index">
        <img :src="loaderGif[index]" />
        <div class="address-list">
          <div>{{ item.title }}</div>
          <div class="address-text">{{ item.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import { modelTypes } from '@/config';
import { exampleDatas } from '@/config/index'

const loadUrl: any = ref({})
const store = useStore()
const router = useRouter()
const casesList: any = ref({})
const loaderGif: any = ref([]);
const yycjData = [
  {
    title: '博物馆',
    url: require('@/assets/images/ar-images/bwg.png')
  },
  {
    title: '艺术馆',
    url: require('@/assets/images/ar-images/ysg.png')
  },
  {
    title: '科技馆',
    url: require('@/assets/images/ar-images/kjg.png')
  },
  {
    title: '历史馆',
    url: require('@/assets/images/ar-images/lsg.png')
  },
  {
    title: '校史馆',
    url: require('@/assets/images/ar-images/xsg.png')
  },
  {
    title: '成果展',
    url: require('@/assets/images/ar-images/cgz.png')
  }
]

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesList.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum ?? 0) - (b.sortNum ?? 0))[0] || {}
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const bwgjs: any = await asynchronousRetrieval('webimg/gif/bwgjs.gif');
  const bwgsd: any = await asynchronousRetrieval('webimg/gif/bwgsd.gif');
  const bwgbj: any = await asynchronousRetrieval('webimg/gif/bwgbj.gif');
  const bwgzj: any = await asynchronousRetrieval('webimg/gif/bwgzj.gif');
  loadUrl.value = { fays_bg }
  loaderGif.value.push(bwgjs, bwgsd, bwgbj, bwgzj);
})
</script>
<style scoped lang="less">
.vr-simulation {
  padding-top: 64rem;
  overflow: hidden;
  width: 100vw;

  .title-text {
    font-weight: bold;
    font-size: 40rem;
    color: #000000;
  }

  .yycj {
    width: 656rem;
    margin-left: 48rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 24rem;
    margin-bottom: 52rem;

    &>div {
      position: relative;
      width: 318rem;
      height: 204rem;
      border-radius: 16rem;
      overflow: hidden;
      margin-bottom: 20rem;

      img {
        width: 318rem;
      }

      .content-title {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 40rem;
        text-align: center;
        background: rgba(46,118,255,0.7);
        line-height: 40rem;
        font-weight: 500;
        font-size: 20rem;
        color: #FFFFFF;
      }
    }
  }

  .sljs {
    margin-top: 36rem;
    width: 656rem;
    margin-left: 48rem;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
      border-radius: 24rem;
    }

    .address-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 28rem;
      color: #414141;
      margin: 16rem 0 48rem;

      .address-text {
        position: relative;
        font-weight: 500;
        font-size: 24rem;
        color: #3D566C;

        &::before {
          content: '';
          width: 22rem;
          height: 29rem;
          position: absolute;
          left: -34rem;
          top: 0;
          background-image: url(~@/assets/images/ar-images/nav-icon.png);
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
